import {
  IAssignmentContextRequest,
  IAssignmentContextResponse,
  IAssignmentNormalizedItem,
  IAssignmentSubmissionDetails,
} from '@/entities/Assignment';
import { formatLondonDateTime } from '@/shared/lib/utils/formatLondonDateTime';
import { formatLongDate } from '@/shared/lib/utils/formatLongDate';

export const parseAssignmentRouteParams = (
  groupLessonId?: string,
  groupExamResubmissionId?: string,
): { params: IAssignmentContextRequest; skip: boolean } => {
  const groupLessonIdNumber = groupLessonId ? Number(groupLessonId) : undefined;
  const groupExamResubmissionIdNumber = groupExamResubmissionId
    ? Number(groupExamResubmissionId)
    : undefined;
  const skip =
    (!groupLessonIdNumber || Number.isNaN(groupLessonIdNumber)) &&
    (!groupExamResubmissionIdNumber || Number.isNaN(groupExamResubmissionIdNumber));

  return {
    params: {
      groupLessonId: groupLessonIdNumber,
      groupExamResubmissionId: groupExamResubmissionIdNumber,
    },
    skip,
  };
};

export const normalizeAssignmentDetailsItem = ({
  submission,
  assignmentContext,
}: {
  submission: IAssignmentSubmissionDetails | null;
  assignmentContext: IAssignmentContextResponse & { assignment: NonNullable<IAssignmentContextResponse['assignment']> };
}): IAssignmentNormalizedItem => ({
  module: {
    id: assignmentContext.module.id,
    title: assignmentContext.module.title,
  },
  lesson: {
    id: assignmentContext.lesson.id,
    groupLessonId: assignmentContext.lesson.groupLessonId ?? undefined,
    groupExamResubmissionId: assignmentContext.lesson.groupExamResubmissionId ?? undefined,
    title: assignmentContext.lesson.title,
    order: assignmentContext.lesson.order,
    createdAt: formatLondonDateTime(assignmentContext.lesson.scheduledAt),
    deadline: formatLongDate(assignmentContext.lesson.endDate),
    type: assignmentContext.lesson.type,
  },
  assignment: {
    id: assignmentContext.assignment.id,
    title: assignmentContext.assignment.text,
    description: assignmentContext.assignment.description,
    attempts: assignmentContext.assignment.attempts,
    attachments: assignmentContext.assignment.attachments,
  },
  moduleTeacher: assignmentContext.moduleTeacher ?? null,
  lecturer: assignmentContext.lecturer ?? null,
  submissionId: submission?.id ?? null,
  grade: submission?.grade ?? null,
  assignmentStatus: submission?.assignmentStatus ?? null,
  submissionSubmittedAt: submission?.submittedAt
    ? formatLondonDateTime(submission.submittedAt)
    : null,
  retake:
    assignmentContext.assignment.attempts && submission?.reviewCount
      ? assignmentContext.assignment.attempts - submission.reviewCount
      : assignmentContext.assignment.attempts, // remaining attempts to submit the assignment
  turnitinData: submission?.turnitin ?? null,
});
